import { FiltersApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useFiltersAPI(): FiltersApi {
  return new FiltersApi(apiConfig);
}
